import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import webTokenStorer from '../../utils/webStorer';
import { LOGIN, SOCIETY_CONTROLLER } from '../routes';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = () => {
    const { loading, reloginLoading } = useSelector(state => state.adminLoginReducer);
    const isLoggedIn = !!(webTokenStorer.getToken2());

    return isLoggedIn ?
        <>
            {(loading || reloginLoading) ?
                <div className='tw-w-full tw-h-screen tw-flex tw-items-center tw-justify-center'>
                    <CircularProgress size="3rem" />
                </div>
                :
                <Outlet />
            }
        </>
        :
        <Navigate to={SOCIETY_CONTROLLER + LOGIN} />
}

export default ProtectedRoute;
